export default {
    corners: state => state.corners,
    cornersInit: state => state.cornersInit,
    projects: state => state.projects,
    projectsLoading: state => state.projectsLoading,
    projectsCipLoading: state => state.projectsCipLoading,
    myProjects: state => state.myProjects,
    myProjectsLoading: state => state.myProjectsLoading
};
